import React, { Component } from 'react';
// import IndexView from './IndexView/IndexView';
// import AppartmentView from './AppartmentView/AppartmentView';
import { connect } from 'react-redux'

import Router from './router'

const App = (props) => (
    <Router {...props} />
)

const fetchAppartmentsHOC = (WrappedComp) => {
    const comp = class extends Component {
        componentWillMount() {
            const { dispatch } = this.props;

            dispatch({ type: 'XRETRIEVE_APPARTMENTS' });
        }

        render() {
            return <WrappedComp {...this.props} />
        }
    }

    return connect()(comp)
}

const fetchVideosHOC = (WrappedComp) => {
    const comp = class extends Component {
        componentWillMount() {
            const { dispatch } = this.props;

            dispatch({ type: 'XRETRIEVE_VIDEOS' });
        }

        render() {
            return <WrappedComp {...this.props} />
        }
    }

    return connect()(comp)
}

const fetchTextsHOC = (WrappedComp) => {
    const comp = class extends Component {
        componentWillMount() {
            const { dispatch, language } = this.props;

            dispatch({ type: 'XRETRIEVE_TEXTS', language });
        }

        render() {
            return <WrappedComp {...this.props} />
        }
    }

    return connect()(comp)
}

const loaderHOC = (WrappedComp) => {
    const comp = class extends Component {
        componentWillMount() {
            const { dispatch, language } = this.props;

            dispatch({ type: 'XRETRIEVE_TEXTS', language });
        }

        render() {
            const { appartments, texts, videos } = this.props;

            if(!appartments.length || !videos.length || !texts.length) {
                return <div className="loaderGeneral"><div className="kozySliderSpinner" /></div>
            }
            else {
                return <WrappedComp {...this.props} />
            }

        }
    }

    return connect( ( state ) => state.app )(comp)
}

export { App };
export default fetchTextsHOC(fetchVideosHOC(fetchAppartmentsHOC(loaderHOC(App))));



// WEBPACK FOOTER //
// ./src/components/App.js